import type { TourDefinition } from '../types'

export const costTour: TourDefinition = {
  id: 'cost',
  title: 'Cost Dashboard Tour',
  description: 'Track execution costs, set budgets, and understand billing attribution.',
  icon: 'DollarSign',
  roles: ['tenant_owner', 'tenant_admin'],
  route: '/tenant/cost',
  estimatedMinutes: 2,
  steps: [
    {
      element: '[data-tour-id="cost-summary"]',
      popover: {
        title: 'Cost Summary',
        description: 'Month-to-date spend across all workflow engines. Costs are attributed within 5 minutes of execution completion.',
      },
      roles: ['tenant_owner', 'tenant_admin'],
      aiContext: 'How does Vharta calculate and attribute workflow execution costs?',
    },
    {
      element: '[data-tour-id="cost-by-workflow"]',
      popover: {
        title: 'Cost by Workflow',
        description: 'Drill down into per-workflow cost. Identify expensive workflows and optimize their scheduling.',
      },
      roles: ['tenant_owner', 'tenant_admin'],
      aiContext: 'How do I identify which workflows are driving most of my compute costs?',
    },
    {
      element: '[data-tour-id="budget-alerts"]',
      popover: {
        title: 'Budget Alerts',
        description: 'Set spending thresholds. Vharta sends notifications when you reach 80% and 100% of your budget.',
      },
      roles: ['tenant_owner', 'tenant_admin'],
      aiContext: 'How do I configure a monthly budget alert for my tenant?',
    },
  ],
}
